module.exports = __webpack_public_path__ + "media/images/xpass/icons/search-pin-950d6548f93484b1c2d2c224c9bce32b.svg";